import AddBlock from '@clearkit/icons/glyphs/AddBlock';
import AddHollow from '@clearkit/icons/glyphs/AddHollow';
import { CKButton, CKTooltip } from '@clearkit/react';
import { v4 as uuidv4 } from 'uuid';

import Footer from '~/components/Footer';

const FieldMappingFooter = ({
  addMapping,
  areFieldMappingsValid,
  className,
  isUpdating,
  setConfirmSaveDialogOpen,
  setShowInvalidFields,
  hasEnrichmentBetaUIFlag,
}) => {
  const SaveButton = () => {
    return (
      <CKButton
        isLoading={isUpdating}
        onClick={() => setConfirmSaveDialogOpen(true)}
        variant={CKButton.Variant.bold}
        isDisabled={areFieldMappingsValid}
        dataTestId="FieldMappingFooter__submit"
        variantColor={CKButton.VariantColor.green}>
        Save changes
      </CKButton>
    );
  };

  const AddButtons = () => {
    return (
      <>
        {hasEnrichmentBetaUIFlag ? (
          <div>
            <CKButton
              onClick={() => addMapping()}
              className="mr-4"
              variant="bold"
              variantColor="blue"
              leftIcon={<AddBlock />}>
              Add mapping
            </CKButton>
            <CKButton
              onClick={() => addMapping({ groupId: uuidv4() })}
              variantColor="blue"
              leftIcon={<AddBlock />}>
              Add address group
            </CKButton>
          </div>
        ) : (
          <div>
            <CKButton
              onClick={() => addMapping()}
              className="mr-4"
              leftIcon={<AddHollow />}>
              Add mapping
            </CKButton>
            <CKButton
              onClick={() => addMapping({ groupId: uuidv4() })}
              leftIcon={<AddHollow />}>
              Add address group
            </CKButton>
          </div>
        )}
      </>
    );
  };

  return (
    <Footer
      isBottomSticky={!hasEnrichmentBetaUIFlag}
      classes={className}
      left={
        <div>
          <AddButtons />
        </div>
      }
      right={
        areFieldMappingsValid ? (
          <div style={{ paddingRight: '2.25rem' }}>
            <CKTooltip
              unstable_portal={false}
              tooltip={<p className="m-2">Some field mappings are invalid</p>}
              placement="top">
              <div
                onMouseEnter={() => setShowInvalidFields(true)}
                onMouseLeave={() => setShowInvalidFields(false)}>
                <SaveButton />
              </div>
            </CKTooltip>
          </div>
        ) : (
          <SaveButton />
        )
      }
    />
  );
};

export default FieldMappingFooter;
